export const EMPTY_ANSWER_LABEL = '(Empty answer)';
export const EMPTY_ROW_LABEL = '(Empty statement)';
export const EMPTY_ROWS_LABEL = '(Empty statements)';
export const EMPTY_COLUMN_LABEL = '(Empty scale point)';
